import { Check, ChevronRight, Calendar, UserPlus, Code, Award } from 'lucide-react';
import './Steps.css';

const Steps = () => {
  const stages = [
    {
      title: "Регистрация",
      date: "14 июля - 31 июля",
      icon: <UserPlus className="step-icon" />,
      completed: true
    },
    {
      title: "Открытие хакатона",
      date: "1 августа 12:00",
      icon: <Calendar className="step-icon" />,
      completed: true
    },
    {
      title: "Хакатон и защита",
      date: "1 - 8 августа",
      icon: <Code className="step-icon" />,
      completed: true
    },
    {
      title: "Закрытие",
      date: "8 июля 16:00",
      icon: <Award className="step-icon" />,
      completed: true
    }
  ];
  

  return (
    <section className="steps-section">
      <div className="steps-container">
        <div className="steps-header">
          <h1>Этапы хакатона</h1>
          <div className="timeline-line"></div>
        </div>

        <div className="steps-list">
          {stages.map((stage, index) => (
            <div className={`step-item ${stage.completed ? 'completed' : ''}`} key={index}>
              <div className="step-marker">
                {stage.completed ? (
                  <Check className="check-icon" />
                ) : (
                  <div className="step-number">{index + 1}</div>
                )}
              </div>
              <div className="step-content">
                <div className="step-icon-container">
                  {stage.icon}
                </div>
                <div>
                  <h3>{stage.title}</h3>
                  <p className="step-date">{stage.date}</p>
                </div>
              </div>
              {/* {!stage.completed && <ChevronRight className="arrow-icon" />} */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
